<template>
    <div>
         <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>宽带录单</el-breadcrumb-item>
    </el-breadcrumb>
    
    <el-form ref="ruleForm" :model="form" :rules="rules"  label-width="80px"  class="form" >
    <el-form-item label="客户姓名" prop="u_name" class="s_input">
     <el-input v-model="form.u_name"></el-input>
  </el-form-item>

   <el-form-item label="联系方式"  prop="phone" class="s_input">
    <el-input v-model="form.phone"></el-input>
  </el-form-item>

  <el-form-item label="供应商" prop="provide">
    <el-select v-model="form.provide" placeholder="请选择宽带供应商"  >
      <el-option  v-for="(item,i) in provides"  :key="i" :label="item.name"  :value="item.id"></el-option>
  
    </el-select>
  </el-form-item> 

 <!-- <el-form-item label="归属地" prop="belong">
    <el-select v-model="form.belong" placeholder="请选择宽带归属地" >
      <el-option  v-for="(item,i) in belongs"  :key="i" :label="item.name"  :value="item.id"></el-option>
  
    </el-select>
  </el-form-item>  -->


  <el-form-item label="宽带类型" prop="type">
    <el-select v-model="form.type" placeholder="请选择宽带类型"  @change="sle_change">
      <el-option   v-for="(item,key)  in typeData"   :key="key"  :label="item['name']" :value="item['id']"></el-option>

      <!-- <el-option label="和商务宽带" value="和商务宽带"></el-option>
      <el-option label="融合宽带" value="融合宽带"></el-option>
      <el-option label="成都宽带" value="成都宽带"></el-option>
      <el-option label="昆明电信宽带" value="昆明电信宽带"></el-option>
      <el-option label="山西移动宽带" value="山西移动宽带"></el-option>
      <el-option label="广东宽带" value="广东宽带"></el-option> -->
    </el-select>
  </el-form-item>
  <el-form-item label="宽带套餐" prop="mbps">
    <el-select v-model="form.mbps" placeholder="请选择宽带套餐" >
      <el-option   v-for="(item,i) in mbpsData"   :key="i" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </el-form-item>


  <el-form-item label="安装地址"  prop="place" >
    <el-input v-model="form.place"></el-input>
  </el-form-item>

<el-form-item label="快递单号"  prop="express_order_number"  class="s_input">
    <el-input v-model="form.express_order_number" ></el-input>
  </el-form-item>
   
    <el-form-item label="集团ID"  prop="group_id" class="s_input">
        <el-input v-model="form.group_id"></el-input>
      </el-form-item>
    <!-- <el-form-item label="集团名称"  prop="group_name" class="s_input">
        <el-input v-model="form.group_name"></el-input>
      </el-form-item> -->
  <el-form-item label="宽带账号" prop="account" class="s_input">
    <el-input v-model="form.account"></el-input>
  </el-form-item>
   <el-form-item label="订单号" prop="order_no"  v-if="showOrderId" class="s_input">
    <el-input v-model="form.order_no"></el-input>
  </el-form-item>

    <el-form-item label="下单时间" prop="order_time" class="s_input">
      <el-date-picker
      v-model="form.order_time"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择下单日期">
    </el-date-picker>
  </el-form-item>

    <el-form-item label="金额" prop="money" class="s_input">
    <el-input v-model="form.money"></el-input>
  </el-form-item>

     <el-form-item label="到期时间" prop="expires_times" class="s_input">
        <el-date-picker
          v-model="form.expires_times"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择到期日期">
        </el-date-picker>
    </el-form-item>

  <el-form-item label="业务员" prop="salesman">
    <el-select v-model="form.salesman" placeholder="请选择业务员">
       <el-option  v-for="(items,index) in salesmanList"   :key="index"  :label="items.name"  :value="items.userId"></el-option>
      
    </el-select>
  </el-form-item>

  <el-form-item label="订单状态">
    <el-select v-model="form.status" placeholder="订单未选择">
      <el-option   v-for="items,index in statusList"  :key="index" :label="items.name" :value="items.code"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="备注">
    <el-input type="textarea" v-model="form.desc"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary"  :loading="loading" @click="onSubmit('ruleForm')">立即提交</el-button>
    <el-button>取消</el-button>
  </el-form-item>
</el-form>
    <el-dialog
  title="土洲宽带提交"
  :visible.sync="tzshow"
  width="50%"
  >
  <tzorder  :formdata="form"  @listenOrder="callForm" />
</el-dialog>

    </div>
</template>

<script>

import { addOrder,salesmanList,getMealData,getTypeData,getprovide,getbelong,getStatus,get_role} from '../../api/order'
import tzorder from '@/components/tzorder.vue'
export default {

    created(){
      this.init();
    },
   data(){
        return{
            tzshow:false,//土洲显示
            showOrderId:true,
            statusList:[],
            typeData:[],
          //  belongs:[],
            statusList:[],
            provides:[],
            salesmanList:[],
            mbpsData:[],
            loading:false,
            mbpsIndex:0,
            form:{
                u_name:'',
                type:'',
                mbps:'',
                place:'',
                group_id:'',
                account:'',
                order_no:'',
                salesman:'',
                phone:'',
                money:'',
                desc:'',
                expires_times:'',
              //  group_name:'',
                order_time:'',
                provide:'',
               // belong:'',
                status:3,
                express_order_number:"",
              
            },
             rules: {

              u_name:[
                 { required: true, message: '请输入客户姓名', trigger: 'blur'}
              ],
              type:[
                 { required: true, message: '请选择宽带类型', trigger: 'blur'}
              ],
              mbps:[
                 { required: true, message: '请选择宽带兆数', trigger: 'blur'}
              ],
              place:[
                 { required: true, message: '填写宽带安装地址', trigger: 'blur'}
              ],
              order_time:[
                 { required: true, message: '下单日期不能为空', trigger: 'blur'}
              ],
              provide:[
                 { required: true, message: '供应商不能为空', trigger: 'blur'}
              ],
              //  belong:[
              //    { required: true, message: '归属地不能为空', trigger: 'blur'}
              // ],
              //  group_id:[
              //    { required: true, message: '集团ID不能为空', trigger: 'blur'}
              // ],
              //  account:[
              //    { required: true, message: '宽带账号不能为空', trigger: 'blur'}
              // ],
                order_no:[
                 { required: true, message: '订单号不能为空', trigger: 'blur'}
              ],
              //   salesman:[
              //    { required: true, message: '请选择业务员', trigger: 'blur'}
              // ],
                
                phone: [
                  { required: true, message: '请输入手机号码', trigger: 'blur' },
                  { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式错误', trigger: 'blur' }
                ],
                money: [
                  { required: true, message: '请输入金额', trigger: 'blur' },
                 // { pattern: /^[\d]+$/, message: '金额必须是整数', trigger: 'blur' }
                ],

        }
            
        }
    },
    methods:{
      callForm(order){
        this.form.orderNumber=order
      },
      init(){
         salesmanList().then(res=>{
            this.salesmanList=res.data;
            });
          getTypeData().then(res=>{
            this.typeData=res.data
          })
            getprovide().then(res=>{
            this.provides=res.data
          })
          //   getbelong().then(res=>{
          //   this.belongs=res.data
          // })
          getStatus().then(res=>{
            this.statusList=res.data
          })
          this.get_role();//获取用户角色
      },

      get_role(){
        get_role().then(res=>{
          if(res.data==10){
            this.showOrderId=true
          }else if(res.data==15){
             this.showOrderId=false;
          }
        })
      },
      sle_belong(data){
        this.form.belong=data;

      },
       sle_provide(data){
        this.form.provide=data;

      },
      onSubmit(formName){
           this.$refs[formName].validate((valid) => {
             if(valid){ 
              if(this.form.provide==22){
                this.tzshow=true;
              }
              return;
                if(this.loading===true){
                    return this.$message({
                      type: 'info',
                      message: '不要重复提交！'
                    });
                }
                  this.loading=true;
                 addOrder(this.form).then(res=>{
                this.$message.success('提交完成'); 
                this.$router.push({
                  path:'/order/Order'
                });
              })
            }else{
                return false;
            }
              
             
           })
      },
 
      handleRest(){
        this.$refs['ruleForm'].resetFields();
      },
      sle_change(id){
          getMealData(id).then(res=>{
            this.form.mbps='';
            this.mbpsData=res.data;
      })

      },
      search(){
        if(!this.pay.phone){
        return  this.$message.error('手机号码不能为空');
        }else{
          if(!/^1[3-9]\d{9}$/.test(this.pay.phone)){
            return this.$message.error('手机号码格式不正确');
          }else{
             return this.$message.success('手机号码查询完成');
          }
        }
      }
    },
    components:{
      tzorder,
    }
}
</script>

    <style scoped lang="scss">
        .user-search{
            margin-top: 20px;
             .input{
                width: 300px;
            }
        }
        .form{
          width: 600px;
          margin: 0 auto;
        }
        .s_input{
          width: 300px;
        }
    </style>


// WEBPACK FOOTER //
// src/views/order/addOrder.vue